export const formatMenu = (menuItems, layer = 1) => {
  return menuItems.map((item, index) => {
    const viewAllItem = [];
    if (item.subMenu && item.webURI) {
      viewAllItem.push({
        id: `${item.id}-all`,
        name: item.mWebShow ? item.mWebShow : `View All ${item.name}`,
        webURI: item.webURI,
      });
    }

    return item.subMenu
      ? {
          id: item.id,
          label: item.name,
          href: item.webURI || null,
          type: item.type || null,
          subMenu: formatMenu([...item.subMenu, ...viewAllItem], layer + 1),
          layer,
          index,
        }
      : {
          id: item.id,
          label: item.name,
          href: item.webURI || null,
          layer,
          index,
        };
  });
};

export const pullMenuByLevel = (menuItems, menuByLevel = []) => {
  menuItems.forEach((menuItem) => {
    if (menuItem.items || menuItem.subMenu) {
      const menuLevel = menuItem.items || menuItem.subMenu;
      menuLevel.forEach((level) => {
        if (!level.parent) {
          level.parent = menuItem.id;
          level.parentLabel = menuItem.label;
        }
      });
      menuByLevel.push(menuLevel);

      return pullMenuByLevel(menuLevel, menuByLevel);
    }
  });

  return menuByLevel;
};

export const getItemAncestry = (item, fullMenu) => {
  const result = [];
  result.push(item);

  for (const key in fullMenu) {
    const subMenu = fullMenu[key].subMenu || [];
    const parentItem = subMenu.find((menuItem) => menuItem.id === item.parent);
    if (parentItem) {
      delete parentItem.subMenu;
      delete fullMenu[key].subMenu;
      result.push(parentItem, fullMenu[key]);
      break;
    }
  }

  return result;
};
